import { compose, withProps } from 'recompose'
import QuotedItemsAndServicesList from './QuotedItemsAndServicesList'
import { getPhoneNumberFromObjectWithPrefix, composeFormattedPhoneNumberFromObject } from 'helpers/phone-number'

const withAppointmentPhonesProps = withProps(({ phoneNumber }) => ({
  storePhoneNumber: composeFormattedPhoneNumberFromObject(phoneNumber),
  formattedStorePhoneNumber: getPhoneNumberFromObjectWithPrefix(phoneNumber)
}))

export default compose(
  withAppointmentPhonesProps
)(QuotedItemsAndServicesList)
